export default __webpack_public_path__ + "static/media/app_store_ko_light.97efaa84.svg";